import { useCallback, useEffect, useRef } from 'react';
import { localStorageStrategy } from './localStorageStrategy';
export const useNotShowAgain = (scenario, storage = localStorageStrategy) => {
    const storedValue = useRef(false);
    const setNotShowAgain = useCallback(() => {
        storage.set(scenario, true);
        storedValue.current = true;
    }, [scenario, storage]);
    useEffect(function setInitialStoredValue() {
        storage.get(scenario).then((value) => {
            storedValue.current = value;
        });
    }, [scenario, storage]);
    return { notShowAgain: storedValue, saveNotShowAgain: setNotShowAgain };
};
